import State from './state';

export function setCriterionList(state, data) {
  let aux = state.criterion_list;
  state.criterion_list = {};
  state.criterion_list = aux;
  state.criterion_list[data.childId] = data.data;
}

export function setEditableDays(state = State, { editableDates = [] }) {
  state.editableDates = editableDates.filter((date) => !state.editableDates.includes(date));
}

export function setAvilableDays(state = State, { availableDates, childId }) {
  state.availableDates = { ...state.availableDates, [childId]: [...availableDates] };
}

export function setCriterionValues(state = State, { values = [], orderResponse, childId, date }) {
  let rawCriterion = [];
  if (orderResponse) {
    const orders = orderResponse['time_day_order'];
    const timeDaysOrder = {};
    orders.forEach(
      (order) =>
        (timeDaysOrder[order.time_day] = Array.isArray(order.ordered_ids) ? order.ordered_ids : []),
    );
    values.forEach((value) => {
      const criterions = value.criterion || [];
      const timeOrder = timeDaysOrder[value.time_day];
      const criterionResponse = criterions
        .map((criterion) => ({
          ...criterion,
          order: timeOrder.indexOf(criterion.challenge_criterion),
        }))
        .sort(function(a, b) {
          return a.order - b.order;
        });
      rawCriterion.push({ ...value, criterion: criterionResponse });
    });
  } else {
    rawCriterion = values;
  }
  state.criterionValues = { ...state.criterionValues, [childId]: { [date]: rawCriterion } };
}

export function addCriterionValues(state, data) {
  let aux = { ...state.criterionValues };
  state.criterionValues = {};
  if (!(data.childId in aux)) {
    aux[data.childId] = {};
  }
  state.availableDates[data.childId] = [];
  /* Proccess Avaliable days */
  if ('avilable_days' in data.data) {
    let availableDates = data.data['avilable_days'];
    delete data.data['avilable_days'];
    availableDates.forEach((element) => {
      if (!(element in aux[data.childId])) {
        aux[data.childId][element] = [];
      }
      state.availableDates[data.childId].push(element);
    });
  }
  /* Proccess Editable days */
  if ('editable_days' in data.data) {
    let editableDates = data.data['editable_days'];
    delete data.data['editable_days'];
    editableDates.forEach((element) => {
      if (!state.editableDates.includes(element)) {
        state.editableDates.push(element);
      }
    });
  }
  /* Proccess Criterion values */
  if (data.orderResponse) {
    let orders = data.orderResponse['time_day_order'];
    let timeDaysOrder = {};
    orders.forEach((element) => {
      timeDaysOrder[element.time_day] = element.ordered_ids;
    });
    Object.keys(data.data).forEach(function(key) {
      let response = [];
      let CriterionData = data.data[key];
      CriterionData.forEach((element) => {
        let CriterionResponse = [];
        let Criterion = element.criterion;
        let timeOrder = timeDaysOrder[element.time_day];
        Criterion.forEach((CriterionElement) => {
          let CriterionElementCopy = { ...CriterionElement };
          CriterionElementCopy.order = timeOrder.indexOf(CriterionElement.challenge_criterion);
          CriterionResponse.push(CriterionElementCopy);
        });

        const elementCopy = { ...element };
        CriterionResponse = CriterionResponse.sort(function(a, b) {
          return a.order - b.order;
        });
        elementCopy.criterion = CriterionResponse;
        response.push(elementCopy);
      });
      aux[data.childId][key] = response;
    });
  } else {
    Object.keys(data.data).forEach(function(key) {
      aux[data.childId][key] = data.data[key];
    });
  }
  state.criterionValues = aux;
}

export function setCriterionToday(state, data) {
  if (data.order['challenges_order'] && data.order['challenges_order']['time_day_order']) {
    let orders = data.order['challenges_order']['time_day_order'];
    var timeDaysOrder = {};
    orders.forEach((element) => {
      timeDaysOrder[element.time_day] = element.ordered_ids;
    });
    var response = [];
    data.data.forEach((element) => {
      var CriterionResponse = [];
      if (element.criterion) {
        var Criterion = element.criterion;
        let timeOrder = timeDaysOrder[element.time_day];
        Criterion.forEach((CriterionElement) => {
          var CriterionElementCopy = { ...CriterionElement };
          CriterionElementCopy.order = timeOrder.indexOf(CriterionElement.challenge_criterion);
          CriterionResponse.push(CriterionElementCopy);
        });

        var elementCopy = { ...element };
        CriterionResponse = CriterionResponse.sort(function(a, b) {
          return a.order - b.order;
        });
        elementCopy.criterion = CriterionResponse;
        response.push(elementCopy);
      }
    });
    state.criterionToday = response;
  } else {
    state.criterionToday = data.data;
  }
}

export function addCriterionImage(state, newImage) {
  const images = [...state.criterionImages];
  images.push(newImage);
  state.criterionImages = images;
}

export function cleanErrors(state) {
  state.error = '';
}

export function error(state, err) {
  state.error = err;
}

export function setCriterionCategories(state, data) {
  state.criterionCategories = data;
}

export function setCriterionImages(state, data) {
  state.criterionImages = data;
}

export function setCriterionTimeFrequencyChoices(state, data) {
  state.criterionTimeFrequencyChoices = data;
}

export function setCriterionTimeDayChoices(state, data) {
  state.criterionTimeDayChoices = data;
}

export function setCriterionDaysOfWeek(state, data) {
  state.criterionDaysOfWeek = data;
}
export function setPredefinedCriterion(state, data) {
  state.predefinedCriterion = data;
}

export function setPossibleStarsToday(state, todayChallenges) {
  const totalCriterionsChallenges = todayChallenges.map((challenge) => challenge.criterion).flat(1);
  const posibleStars = totalCriterionsChallenges.reduce(
    (total, criterio) => total + criterio.coin_value,
    0,
  );

  state.posibleStarsToday = posibleStars;
}

export function setHomeChallengeSkill(state = State, homeChallengeSkillId = 0) {
  state.home_challenge_skill_id = homeChallengeSkillId;
}

export function updateStarToChild(state = State, data) {
  state.starsEarned = data.startsEarned;
}
